/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../model/model';
import '../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "stockorders": {
        "nested": {
          "message": {
            "nested": {
              "LineToCreate": {
                "fields": {
                  "itemVariationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "quantityOrdered": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreateTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sourceUnitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "destinationUnitToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "expectedOnUnixMillis": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "linesToCreate": {
                    "type": "squareup.stockorders.message.LineToCreate",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "trackingNumber": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "createdByEmploymentToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "CreateTransferOrderResponse": {
                "fields": {
                  "transferOrder": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateInstantTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sourceUnitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "destinationUnitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "expectedOnUnixMillis": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "linesToCreate": {
                    "type": "squareup.stockorders.message.LineToCreate",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "trackingNumber": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdByEmploymentToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "CreateInstantTransferOrderResponse": {
                "fields": {
                  "transferOrder": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StartTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isInstant": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "StartTransferOrderResponse": {
                "fields": {
                  "transferOrder": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "trackingNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "expectedOnUnixMillis": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "fee": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "feeTax": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "transferOrderLineUpdates": {
                    "type": "squareup.stockorders.message.UpdateTransferOrderRequest.TransferOrderLineUpdate",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "sourceUnitToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "destinationUnitToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TransferOrderLineUpdate": {
                    "fields": {
                      "transferOrderLineId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "updateType": {
                        "type": "squareup.stockorders.message.UpdateTransferOrderRequest.TransferOrderLineUpdate.UpdateType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "quantityOrdered": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "itemVariationToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "UpdateType": {
                        "values": {
                          "UPDATE_TYPE_DO_NOT_USE": 0,
                          "INSERT": 1,
                          "DELETE": 2,
                          "UPDATE": 3
                        }
                      }
                    }
                  }
                }
              },
              "UpdateTransferOrderResponse": {
                "fields": {
                  "updatedLines": {
                    "type": "squareup.stockorders.model.TransferOrderLine",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "updatedTransferOrder": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReceiveTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "receiveLines": {
                    "type": "squareup.stockorders.message.ReceiveTransferOrderRequest.ReceiveLine",
                    "id": 4,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ReceiveLine": {
                    "fields": {
                      "transferOrderLineId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "quantityReceived": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "quantityDamaged": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "quantityCanceled": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ReceiveTransferOrderResponse": {
                "fields": {
                  "receivedLines": {
                    "type": "squareup.stockorders.model.TransferOrderLine",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SearchTransferOrdersRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "query": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.stockorders.message.SearchTransferOrdersRequest.Filter",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "sortOrder": {
                    "type": "squareup.stockorders.message.SearchTransferOrdersRequest.TransferOrdersSort",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "pageSize": {
                    "type": "int32",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filter": {
                    "fields": {
                      "filterType": {
                        "type": "squareup.stockorders.message.SearchTransferOrdersRequest.Filter.TransferOrderFilterType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "filterValues": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "TransferOrderFilterType": {
                        "values": {
                          "TRANSFER_ORDER_FILTER_TYPE_DO_NOT_USE": 0,
                          "SOURCE_LOCATION": 1,
                          "DESTINATION_LOCATION": 2,
                          "STATE": 3,
                          "ORDER_NUMBER": 4
                        }
                      }
                    }
                  },
                  "TransferOrdersSort": {
                    "fields": {
                      "sortProperty": {
                        "type": "squareup.stockorders.message.SearchTransferOrdersRequest.TransferOrdersSort.TransferOrdersSortProperty",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sortOrder": {
                        "type": "squareup.stockorders.message.SearchTransferOrdersRequest.TransferOrdersSort.SortOrder",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TransferOrdersSortProperty": {
                        "values": {
                          "TRANSFER_ORDER_SORT_PROPERTY_DO_NOT_USE": 0,
                          "STATE": 1,
                          "LAST_UPDATED": 2,
                          "CREATED_AT": 3
                        }
                      },
                      "SortOrder": {
                        "values": {
                          "SORT_ORDER_DO_NOT_USE": 0,
                          "ASC": 1,
                          "DSC": 2
                        }
                      }
                    }
                  }
                }
              },
              "SearchTransferOrdersResponse": {
                "fields": {
                  "transferOrders": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetTransferOrdersRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferOrderIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "GetTransferOrdersResponse": {
                "fields": {
                  "transferOrders": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CancelTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CancelTransferOrderResponse": {
                "fields": {
                  "transferOrder": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DeleteTransferOrderRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotencyToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "DeleteTransferOrderResponse": {
                "fields": {
                  "transferOrder": {
                    "type": "squareup.stockorders.model.TransferOrder",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.LineToCreate && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.CreateTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.CreateTransferOrderResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.CreateInstantTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.CreateInstantTransferOrderResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.StartTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.StartTransferOrderResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.UpdateTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.UpdateTransferOrderRequest?.nested?.TransferOrderLineUpdate && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.UpdateTransferOrderRequest?.nested?.TransferOrderLineUpdate?.nested?.UpdateType && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.UpdateTransferOrderResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.ReceiveTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.ReceiveTransferOrderRequest?.nested?.ReceiveLine && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.ReceiveTransferOrderResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersRequest?.nested?.Filter && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersRequest?.nested?.Filter?.nested?.TransferOrderFilterType && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersRequest?.nested?.TransferOrdersSort && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersRequest?.nested?.TransferOrdersSort?.nested?.TransferOrdersSortProperty && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersRequest?.nested?.TransferOrdersSort?.nested?.SortOrder && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrdersResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.GetTransferOrdersRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.GetTransferOrdersResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.CancelTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.CancelTransferOrderResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.DeleteTransferOrderRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.DeleteTransferOrderResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LineToCreate @ squareup/stockorders/message/transfer_orders.proto at 11:1
 */
export const LineToCreate = $root.lookupType('squareup.stockorders.message.LineToCreate');
fixType(LineToCreate);
Builder.createAndAttachToType(LineToCreate);
/**
 * Creates a transfer order with no item variations, or from bulk selected item variations.
 * This endpoint should only be used to create non-instant transfers;
 * this endpoint will always create transfer orders in the draft state.
 *
 * SOURCE CreateTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 21:1
 */
export const CreateTransferOrderRequest = $root.lookupType('squareup.stockorders.message.CreateTransferOrderRequest');
fixType(CreateTransferOrderRequest);
Builder.createAndAttachToType(CreateTransferOrderRequest);
/**
 * SOURCE CreateTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 64:1
 */
export const CreateTransferOrderResponse = $root.lookupType('squareup.stockorders.message.CreateTransferOrderResponse');
fixType(CreateTransferOrderResponse);
Builder.createAndAttachToType(CreateTransferOrderResponse);
/**
 * Creates an instant transfer. This endpoint will mark all items in the transfer as received at the destination.
 *
 * SOURCE CreateInstantTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 72:1
 */
export const CreateInstantTransferOrderRequest = $root.lookupType('squareup.stockorders.message.CreateInstantTransferOrderRequest');
fixType(CreateInstantTransferOrderRequest);
Builder.createAndAttachToType(CreateInstantTransferOrderRequest);
/**
 * SOURCE CreateInstantTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 100:1
 */
export const CreateInstantTransferOrderResponse = $root.lookupType('squareup.stockorders.message.CreateInstantTransferOrderResponse');
fixType(CreateInstantTransferOrderResponse);
Builder.createAndAttachToType(CreateInstantTransferOrderResponse);
/**
 * Starts a transfer order by updating the state to IN_PROGRESS and creating adjustments in Inventory2
 * that move the stock from IN_STOCK @ source → IN_TRANSIT @ destination.
 *
 * SOURCE StartTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 109:1
 */
export const StartTransferOrderRequest = $root.lookupType('squareup.stockorders.message.StartTransferOrderRequest');
fixType(StartTransferOrderRequest);
Builder.createAndAttachToType(StartTransferOrderRequest);
/**
 * SOURCE StartTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 121:1
 */
export const StartTransferOrderResponse = $root.lookupType('squareup.stockorders.message.StartTransferOrderResponse');
fixType(StartTransferOrderResponse);
Builder.createAndAttachToType(StartTransferOrderResponse);
/**
 * Updates the lines that comprise a transfer order.
 * Line items may be added or deleted.
 *
 * SOURCE UpdateTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 129:1
 */
export const UpdateTransferOrderRequest = $root.lookupType('squareup.stockorders.message.UpdateTransferOrderRequest');
fixType(UpdateTransferOrderRequest);
Builder.createAndAttachToType(UpdateTransferOrderRequest);
/**
 * Item variation should only be provided for line inserts
 * Line id is required for deletes and updates
 * Only the total quantity ordered for an item may be updated with this endpoint
 *
 * SOURCE TransferOrderLineUpdate @ squareup/stockorders/message/transfer_orders.proto at 153:3
 */
UpdateTransferOrderRequest.TransferOrderLineUpdate = $root.lookupType('squareup.stockorders.message.UpdateTransferOrderRequest.TransferOrderLineUpdate');
fixType(UpdateTransferOrderRequest.TransferOrderLineUpdate);
Builder.createAndAttachToType(UpdateTransferOrderRequest.TransferOrderLineUpdate);
/**
 * SOURCE UpdateType @ squareup/stockorders/message/transfer_orders.proto at 156:5
 */
UpdateTransferOrderRequest.TransferOrderLineUpdate.UpdateType = $root.lookupEnum('squareup.stockorders.message.UpdateTransferOrderRequest.TransferOrderLineUpdate.UpdateType').values;
/**
 * SOURCE UpdateTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 176:1
 */
export const UpdateTransferOrderResponse = $root.lookupType('squareup.stockorders.message.UpdateTransferOrderResponse');
fixType(UpdateTransferOrderResponse);
Builder.createAndAttachToType(UpdateTransferOrderResponse);
/**
 * Sets the allocation of quantities in the receive flow, i.e. received, canceled, and damaged
 *
 * SOURCE ReceiveTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 186:1
 */
export const ReceiveTransferOrderRequest = $root.lookupType('squareup.stockorders.message.ReceiveTransferOrderRequest');
fixType(ReceiveTransferOrderRequest);
Builder.createAndAttachToType(ReceiveTransferOrderRequest);
/**
 * SOURCE ReceiveLine @ squareup/stockorders/message/transfer_orders.proto at 193:3
 */
ReceiveTransferOrderRequest.ReceiveLine = $root.lookupType('squareup.stockorders.message.ReceiveTransferOrderRequest.ReceiveLine');
fixType(ReceiveTransferOrderRequest.ReceiveLine);
Builder.createAndAttachToType(ReceiveTransferOrderRequest.ReceiveLine);
/**
 * SOURCE ReceiveTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 207:1
 */
export const ReceiveTransferOrderResponse = $root.lookupType('squareup.stockorders.message.ReceiveTransferOrderResponse');
fixType(ReceiveTransferOrderResponse);
Builder.createAndAttachToType(ReceiveTransferOrderResponse);
/**
 * Hits Elasticsearch to search transfer orders by item, order number, or tracking number.
 *
 * SOURCE SearchTransferOrdersRequest @ squareup/stockorders/message/transfer_orders.proto at 214:1
 */
export const SearchTransferOrdersRequest = $root.lookupType('squareup.stockorders.message.SearchTransferOrdersRequest');
fixType(SearchTransferOrdersRequest);
Builder.createAndAttachToType(SearchTransferOrdersRequest);
/**
 * SOURCE Filter @ squareup/stockorders/message/transfer_orders.proto at 223:3
 */
SearchTransferOrdersRequest.Filter = $root.lookupType('squareup.stockorders.message.SearchTransferOrdersRequest.Filter');
fixType(SearchTransferOrdersRequest.Filter);
Builder.createAndAttachToType(SearchTransferOrdersRequest.Filter);
/**
 * SOURCE TransferOrderFilterType @ squareup/stockorders/message/transfer_orders.proto at 224:5
 */
SearchTransferOrdersRequest.Filter.TransferOrderFilterType = $root.lookupEnum('squareup.stockorders.message.SearchTransferOrdersRequest.Filter.TransferOrderFilterType').values;
/**
 * SOURCE TransferOrdersSort @ squareup/stockorders/message/transfer_orders.proto at 238:3
 */
SearchTransferOrdersRequest.TransferOrdersSort = $root.lookupType('squareup.stockorders.message.SearchTransferOrdersRequest.TransferOrdersSort');
fixType(SearchTransferOrdersRequest.TransferOrdersSort);
Builder.createAndAttachToType(SearchTransferOrdersRequest.TransferOrdersSort);
/**
 * SOURCE TransferOrdersSortProperty @ squareup/stockorders/message/transfer_orders.proto at 239:5
 */
SearchTransferOrdersRequest.TransferOrdersSort.TransferOrdersSortProperty = $root.lookupEnum('squareup.stockorders.message.SearchTransferOrdersRequest.TransferOrdersSort.TransferOrdersSortProperty').values;
/**
 * SOURCE SortOrder @ squareup/stockorders/message/transfer_orders.proto at 248:5
 */
SearchTransferOrdersRequest.TransferOrdersSort.SortOrder = $root.lookupEnum('squareup.stockorders.message.SearchTransferOrdersRequest.TransferOrdersSort.SortOrder').values;
/**
 * SOURCE SearchTransferOrdersResponse @ squareup/stockorders/message/transfer_orders.proto at 265:1
 */
export const SearchTransferOrdersResponse = $root.lookupType('squareup.stockorders.message.SearchTransferOrdersResponse');
fixType(SearchTransferOrdersResponse);
Builder.createAndAttachToType(SearchTransferOrdersResponse);
/**
 * Retrieves transfer orders by id.
 *
 * SOURCE GetTransferOrdersRequest @ squareup/stockorders/message/transfer_orders.proto at 274:1
 */
export const GetTransferOrdersRequest = $root.lookupType('squareup.stockorders.message.GetTransferOrdersRequest');
fixType(GetTransferOrdersRequest);
Builder.createAndAttachToType(GetTransferOrdersRequest);
/**
 * SOURCE GetTransferOrdersResponse @ squareup/stockorders/message/transfer_orders.proto at 282:1
 */
export const GetTransferOrdersResponse = $root.lookupType('squareup.stockorders.message.GetTransferOrdersResponse');
fixType(GetTransferOrdersResponse);
Builder.createAndAttachToType(GetTransferOrdersResponse);
/**
 * Cancels a transfer order by updating the state to CANCELED.
 * Transfer orders can be canceled from the draft or IN_PROGRESS state.
 *
 * SOURCE CancelTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 290:1
 */
export const CancelTransferOrderRequest = $root.lookupType('squareup.stockorders.message.CancelTransferOrderRequest');
fixType(CancelTransferOrderRequest);
Builder.createAndAttachToType(CancelTransferOrderRequest);
/**
 * SOURCE CancelTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 298:1
 */
export const CancelTransferOrderResponse = $root.lookupType('squareup.stockorders.message.CancelTransferOrderResponse');
fixType(CancelTransferOrderResponse);
Builder.createAndAttachToType(CancelTransferOrderResponse);
/**
 * Soft deletes a transfer order by updating the state to DELETED.
 *
 * SOURCE DeleteTransferOrderRequest @ squareup/stockorders/message/transfer_orders.proto at 305:1
 */
export const DeleteTransferOrderRequest = $root.lookupType('squareup.stockorders.message.DeleteTransferOrderRequest');
fixType(DeleteTransferOrderRequest);
Builder.createAndAttachToType(DeleteTransferOrderRequest);
/**
 * SOURCE DeleteTransferOrderResponse @ squareup/stockorders/message/transfer_orders.proto at 313:1
 */
export const DeleteTransferOrderResponse = $root.lookupType('squareup.stockorders.message.DeleteTransferOrderResponse');
fixType(DeleteTransferOrderResponse);
Builder.createAndAttachToType(DeleteTransferOrderResponse);